import type { ClockPort } from '../../application';
import { IsoDateTime } from '../../domain';

export class BrowserClockAdapter implements ClockPort {
  now(): IsoDateTime {
    return IsoDateTime.create(new Date().toISOString());
  }
}
